/** Значения из API (snake_case / lowercase) → английская фраза для t() (iomart-hooks строит ключ из неё). */
export function statusValueToI18nPhrase(value: string): string {
  const v = (value || '').trim().toLowerCase();
  const map: Record<string, string> = {
    not_paid: 'Not paid',
    partially_paid: 'Partially paid',
    fully_paid: 'Fully paid',
    completed: 'Completed',
    not_delivered: 'Not delivered',
    partially_delivered: 'Partially delivered',
    fully_delivered: 'Fully delivered',
    drafts: 'Drafts',
    active: 'Active',
    inactive: 'Inactive',
    return: 'Return',
    working: 'Working',
    banned: 'Banned',
    none: 'None',
    failed: 'Failed',
    done: 'Done',
    awaiting: 'Awaiting',
    delivering: 'Delivering',
    delivered: 'Delivered',
    cancelled: 'Cancelled',
  };
  if (map[v]) return map[v];
  if (!v) return '';
  return v
    .split('_')
    .map((w) => w.charAt(0).toUpperCase() + w.slice(1))
    .join(' ');
}
